import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Form, Button, Container } from "react-bootstrap";
import Layout from "../../layout/default";
import Block from "../../components/Block/Block";
import { Link } from "react-router-dom";

// const baseURL = "http://127.0.0.1:8000/storage/";

const UpdatedCustomerPassword = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const handleUpdatePassword = async () => {
        // Check if passwords match
        if (password !== confirmPassword) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Passwords do not match!",
            });
            return;
        }

        // Retrieve the authentication token from localStorage
        const authToken = localStorage.getItem("authToken");

        // Check if the token is missing
        if (!authToken) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Authentication token is missing!",
            });
            return;
        }

        try {
            // Make the API request to update the password
            const response = await axios.put(
                `${process.env.REACT_APP_HOST}api/admin/update-user-password`,
                {
                    email: email,
                    password: password,
                    c_password: confirmPassword,
                },
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            // Display success message
            Swal.fire({
                icon: "success",
                title: "Success",
                text: response.data.message || "Password updated successfully!",
            });

            // Clear the form fields after successful update
            setEmail("");
            setPassword("");
            setConfirmPassword("");
        } catch (error) {
            // Handle errors and display appropriate message
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "An error occurred!",
            });
        }
    };

    return (
        <Layout title="Updated-Customer-Password">
            <Block.HeadContent>
                <ul className="d-flex">
                    <li>
                        <Link
                            to="/shop/admin/admin-panel"
                            className="btn btn-primary btn-md d-md-none"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="/shop/admin/admin-panel"
                            className="btn btn-primary d-none d-md-inline-flex"
                        >
                            <span>Go To Panel</span>
                        </Link>
                    </li>
                </ul>
            </Block.HeadContent>
            <Container className="mt-5" style={{ maxWidth: "500px" }}>
                <h2 className="text-center">Update User Password</h2>
                <Form>
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter email"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Label>New Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter new password"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formConfirmPassword">
                        <Form.Label>Confirm Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm password"
                        />
                    </Form.Group>

                    <Button
                        variant="primary"
                        onClick={handleUpdatePassword}
                        className="w-100"
                    >
                        Update Password
                    </Button>
                </Form>
            </Container>
        </Layout>
    );
};

export default UpdatedCustomerPassword;
